import React from 'react';

const INPUT = 'w-full px-4 py-3 rounded-xl border border-teal-100 outline-none focus:border-teal-400 focus:ring-2 focus:ring-teal-100 transition text-sm';
const AREAS = [
  { k: 'symptoms', label: 'Main symptoms and how long you have had them', required: true },
  { k: 'diagnosis', label: 'Any diagnosis you have been given so far' },
  { k: 'medications', label: 'Current medicines and doses' },
  { k: 'other_conditions', label: 'Other medical conditions or past surgery' },
];

export const HistoryFields = ({ value, onChange }) => {
  const set = (k) => (e) => onChange({ ...value, [k]: e.target.value });
  return (
    <fieldset data-testid="history-form" className="space-y-3 rounded-2xl border border-teal-100 p-4">
      <legend className="px-2 text-sm font-semibold text-teal-900">Medical history</legend>
      <div className="grid sm:grid-cols-3 gap-3">
        <input data-testid="history-age" required inputMode="numeric" value={value.age} onChange={set('age')} placeholder="Age" className={INPUT} />
        <select data-testid="history-sex" value={value.sex} onChange={set('sex')} className={`${INPUT} bg-white`}>
          <option value="">Sex</option><option>Female</option><option>Male</option><option>Other</option>
        </select>
        <input data-testid="history-allergies" value={value.allergies} onChange={set('allergies')} placeholder="Drug allergies" className={INPUT} />
      </div>
      {AREAS.map((a) => (
        <textarea key={a.k} data-testid={`history-${a.k}`} required={a.required} rows={2} value={value[a.k]} onChange={set(a.k)}
          placeholder={a.required ? a.label : `${a.label} (optional)`} className={`${INPUT} resize-none`} />
      ))}
    </fieldset>
  );
};

export const EMPTY_HISTORY = { age: '', sex: '', symptoms: '', diagnosis: '', medications: '', allergies: '', other_conditions: '' };
